import {normalize, schema, denormalize} from 'normalizr';

const categoryLanguage = new schema.Entity('categoriesLanguages', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {categoriesLanguages: [categoryLanguage]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = categoryLanguage;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = categoryLanguage;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default categoryLanguage;
